// Etiquetas legibles para los valores por defecto del catálogo
// "medios_electronicos" (Configuración > Tribunal). Estos son los mismos
// códigos que ya guardan los expedientes de tribunal existentes (ver
// FormTribunal.jsx / PruebasSection.jsx); cualquier opción nueva que se
// agregue en Configuración se muestra tal cual se escribió.
export const MEDIOS_ELECTRONICOS_LABELS = {
  whatsapp: "WhatsApp",
  correo: "Correo",
  sms: "SMS",
  redes_sociales: "Redes sociales",
  audios: "Audios",
  videos: "Videos",
  fotos: "Fotografías",
  capturas: "Capturas",
  plataformas: "Plataformas",
  archivos: "Archivos digitales",
};

export const medioElectronicoLabel = (codigo) =>
  MEDIOS_ELECTRONICOS_LABELS[codigo] || codigo;
